<div
  *ngIf="isChartHasData && !isChartLoading"
  id="{{ chartId }}"
  style="flex: 1"
></div>

<div class="no-data" *ngIf="!isChartHasData && !isChartLoading">There is no intraday data for this instrument</div>
